import { useDialog } from "~/src/modules/ui-kit";

import Finder from "../../../../../modules/finder";
import Button from "../../../components/Button";
import SearchBait from "../../../components/SearchBait";
import Unselect from "../../../components/Unselect";
import useSearchKeybind from "../../../components/useSearchKeybind";
import RevitBuiltInParameter from "../../RevitBuiltInParameter/RevitBuiltInParameter";
import * as revitBuiltInParameterSearch from "../../RevitBuiltInParameter/search";


export default function BuiltInParameterConfiguration(props) {
    const { definition, next, prev } = props;

    const [Dialog, open, close] = useDialog();
    useSearchKeybind(open);

    function onChange(id) {
        props.onChange({ id });
    }

    function onSelect(_, id) {
        onChange(id);
        close();
    }

    if (definition?.id) {
        return (
            <>
                <RevitBuiltInParameter
                    distinct
                    id={ definition.id }
                    onClick={ () => onChange(undefined) }
                >
                    <Unselect />
                </RevitBuiltInParameter>
                <footer>
                    <Button onClick={ prev }>back</Button>
                    <Button onClick={ next }>continue</Button>
                </footer>
            </>
        );
    }

    return (
        <>
            <SearchBait>
                <span>select revit builtin parameter</span>
                <input
                    onFocus={ open }
                    placeholder="Search"
                />
                <span>press <i>/</i> or start typing to search</span>
            </SearchBait>
            <Dialog>
                <Finder
                    modules={ [revitBuiltInParameterSearch] }
                    onSelect={ onSelect }
                    placeholder="Search"
                />
            </Dialog>
            <footer>
                <Button onClick={ prev }>back</Button>
                <Button disabled>continue</Button>
            </footer>
        </>
    );
}
